if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent(focus = true) {
      if (this.modelViewerUI) {
        window.pauseAllMedia();
        this.modelViewerUI.play();
        return;
      }
      if (this.modelViewerUIPending) return;
      this.modelViewerUIPending = true;
      this.dispatchEvent(new Event('gallery-model-loading'));
      super.loadContent(focus);
      const viewer = this.querySelector('model-viewer');
      viewer.addEventListener('load', () => {
        this.modelLoaded = true;
        this.notifyReady();
      }, { once: true });
      viewer.addEventListener('error', () => this.dispatchEvent(new Event('gallery-model-error')));
      this.modelLoaded = viewer.loaded;
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      this.modelViewerUIPending = false;
      if (!this.isConnected) return;
      if (errors) {
        this.dispatchEvent(new Event('gallery-model-error'));
        return;
      }
      try {
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'), {
          focusOnPlay: !this.closest('side-gallery'),
        });
        if (this.closest('side-gallery') && !this.closest('[hidden]')) this.modelViewerUI.play();
        this.notifyReady();
      } catch (error) {
        this.dispatchEvent(new Event('gallery-model-error'));
      }
    }

    notifyReady() {
      if (this.modelLoaded && this.modelViewerUI) this.dispatchEvent(new Event('gallery-model-ready'));
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
